import { useQuery, useQueryClient } from 'react-query';
import type { GetApiOptions } from 'types/api';

export function useGetApi<TData>({
  queryKey,
  request,
  ...options
}: GetApiOptions<TData>) {
  const queryClient = useQueryClient();
  const { data, isFetched, isFetching, isLoading, refetch, remove } = useQuery<
    TData,
    unknown
  >(queryKey, request, options);

  return {
    data,
    invalidate: () => queryClient.invalidateQueries(queryKey),
    isFetched,
    isFetching,
    isLoading,
    refetch,
    remove,
  };
}
